
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/tag/[tagPage]",
      function () {
        return require("private-next-pages/articles/tag/[tagPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/tag/[tagPage]"])
      });
    }
  